import { useMutation } from 'react-query';
import { generateIdentityMigrationLinkUrl } from '../urls';
import { APIError } from '~/src/utils/error';

interface MigrationLinkResponse {
  accept_url: string;
}

export const useGenerateIdentityMigrationLink = () => {
  return useMutation<MigrationLinkResponse, APIError, void>({
    mutationFn: async () => {
      const response = await fetch(generateIdentityMigrationLinkUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new APIError(
          'Failed to generate identity migration link',
          response,
        );
      }

      return response.json();
    },
  });
};
